// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"264":"components-payment-CrossSellCart","1517":"components-ApplePayButton-PreviewButton","2321":"client-components-ViewCart","2717":"client-components-ConfirmationCart","4185":"components-payment-RelatedProductsSection","9777":"recorder"}[chunkId] || chunkId) + ".js";
};